var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('Uploader',{model:{value:(_vm.form.img),callback:function ($$v) {_vm.$set(_vm.form, "img", $$v)},expression:"form.img"}})],1),(_vm.permission('cpgl_cpsy_th'))?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.update}},[_vm._v("替换")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }